import React, { FC } from 'react';
import { useTemplatesContext } from '@components/Contexts/TemplatesContext';
import { LANGUAGES_WITHOUT_ALL } from '@common/types';
import MultiSelectionFilter from '@components/Templates/FilterPanel/MultiSelectionFilter';

type Props = {};

const LanguagesFilter: FC<Props> = ({}) => {
  const {
    state: { filters },
  } = useTemplatesContext();

  return (
    <MultiSelectionFilter
      selectedValue={filters.languages}
      items={Object.freeze(LANGUAGES_WITHOUT_ALL)}
      langTokenPrefix={'marketplace.templates-page.language-'}
      updatedQueryParam={'languages'}
      dataHook={'languages'}
      type={'languages'}
    />
  );
};

export default LanguagesFilter;
